import { render, staticRenderFns } from "./logout.vue?vue&type=template&id=37d4d359&scoped=true"
import script from "./logout.vue?vue&type=script&lang=js"
export * from "./logout.vue?vue&type=script&lang=js"
import style0 from "./logout.vue?vue&type=style&index=0&id=37d4d359&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d4d359",
  null
  
)

export default component.exports